import React from "react";
import OwButton from "../../shared/OwButton/OwButton";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwLabel from "../../shared/OwLabel/OwLabel";

type Props = {
    closeModalFn: () => void;
    keepExistingFn: () => void;
    clearCartFn: () => void;
};

export const ReorderConfirmModal: React.FC<Props> = (props) => {
    return (
        <div className={"ReorderConfirmModal p-4"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-cart-plus"} title={"reorder_confirmation"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeModalFn} />
                    </div>
                </div>
            </div>

            <div className={"mt-4 text-center"}>
                <OwLabel title={"cart_has_items_reorder_message"} />
            </div>

            <div className={"mt-5 d-flex justify-content-center gap-3"}>
                <OwButton title={"keep_existing_items"} fn={props.keepExistingFn} />
                <OwButton title={"clear_cart_and_add"} fn={props.clearCartFn} className={"btn-warning"} />
            </div>
        </div>
    );
};
